import { defineStyleConfig } from '@chakra-ui/react'
import type { StyleFunctionProps } from '@chakra-ui/styled-system'

const Tabs = defineStyleConfig({
  sizes: {
    md: {
      tab: {
        p: "15px 0",
        fontSize: "10px",
        lineHeight: "14px",
      },
      tabpanel: {
        p: 0
      }
    }
  },
  variants: {
    primary: (props: StyleFunctionProps) => ({
      tab: {
        color: props.colorMode === "light" ? "navy" : "white",
        bg: props.colorMode === "light" ? "skyGradient" : "alphaWhite005",
        borderBottom: "2px",
        borderColor: "transparent",
        _selected: {
          bg: props.colorMode === "light" ? "skyGradientActive" : "skyGradientActiveDark",
          borderColor: props.colorMode === "light" ? "navy" : "skyBlue",
          color: props.colorMode === "light" ? "navy" : "skyBlue",
        }
      },
      tablist: {
        borderRadius: "8px",
        overflow: "hidden"
      }
    })
  },
  defaultProps: {
    variant: "primary",
    size: "md"
  }
})
export default Tabs